import React from 'react'
import { I18n } from 'react-redux-i18n'

/**
 * InputText
 * @param {object} props
 * @param {String} props.id
 * @param {String} props.label
 * @param {String} props.value
 * @param {String} props.maxLength
 * @param {Function} props.onChange
 * @param {boolean} props.disabled
 * @param {String} props.description
 * @param {String} props.className
 */
const InputText = (props) => {
  const { id, propName, label, value, maxLength, onChange, disabled, description, onlyRead, placeholder, className, type = 'text', min, max, required } = props

  return(
    <div className={`channel-field input ${className ? className : ''}`}>
      {label && <label htmlFor={id}>{I18n.t(label)} <span className='required'>{required ? '*' : ''}</span></label>}
      <div className={`field-content ${!className ? 'grid grid--large' : ''}`}>
        <input
          type={type}
          id={id}
          name={propName}
          maxLength={maxLength}
          value={value}
          onChange={({ target }) => onChange(target.value)}
          disabled={disabled}
          readOnly={onlyRead}
          placeholder={placeholder ? I18n.t(placeholder) : null}
          max={max}
          min={min}
        />
        {description && <p className='description' dangerouslySetInnerHTML={{ __html: I18n.t(description) }} />}
      </div>
    </div>
  )
}

export default InputText
